import SoftCurtain from 'shared/components/atoms/SoftCurtain/SoftCurtain';

export default SoftCurtain;
